var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/16.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [_c("li", [_vm._v("Declaração de Posse")])])
          ]),
          _c(
            "el-col",
            { staticClass: "button-baixar", attrs: { span: 22 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "botao",
                  attrs: {
                    type: "success",
                    loading: _vm.loading,
                    icon: "fas fa-cloud-download-alt"
                  },
                  on: {
                    click: function($event) {
                      return _vm.baixarModelo("declaracao_posse")
                    }
                  }
                },
                [
                  _c("span", [
                    _c("b", { staticClass: "text-botao" }, [_vm._v("Baixar")])
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/16.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [_c("li", [_vm._v("Declaração de Residência")])])
          ]),
          _c(
            "el-col",
            { staticClass: "button-baixar", attrs: { span: 22 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "botao",
                  attrs: {
                    type: "success",
                    loading: _vm.loading,
                    icon: "fas fa-cloud-download-alt"
                  },
                  on: {
                    click: function($event) {
                      return _vm.baixarModelo("declaracao_residencia")
                    }
                  }
                },
                [
                  _c("span", [
                    _c("b", { staticClass: "text-botao" }, [_vm._v("Baixar")])
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-row",
        { staticClass: "dashedBox" },
        [
          _c("el-col", { staticClass: "icon-dashedBox", attrs: { span: 2 } }, [
            _c("img", {
              attrs: { src: require("@/assets/icons/IconesObservacoes/16.png") }
            })
          ]),
          _c("el-col", { staticClass: "text-dashedBox", attrs: { span: 22 } }, [
            _c("ul", [
              _c("li", [
                _vm._v("Declaração Negativa de Propriedade Imóvel Rural")
              ])
            ])
          ]),
          _c(
            "el-col",
            { staticClass: "button-baixar", attrs: { span: 22 } },
            [
              _c(
                "el-button",
                {
                  staticClass: "botao",
                  attrs: {
                    type: "success",
                    loading: _vm.loading,
                    icon: "fas fa-cloud-download-alt"
                  },
                  on: {
                    click: function($event) {
                      return _vm.baixarModelo("declaracao_negativa")
                    }
                  }
                },
                [
                  _c("span", [
                    _c("b", { staticClass: "text-botao" }, [_vm._v("Baixar")])
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-52ab35e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52ab35e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/portal/publico/components/informacao/ModelosDocumentos.vue
// module id = null
// module chunks = 